import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import './Help.css';
import './PageShell.css';

export default function Help() {
  const { language } = useLanguage();
  const text = language === 'zh' ? {
    title: '帮助中心',
    subtitle: '快速了解Oblitrok的核心流程，遇到问题时也能找到下一步该做什么。',
    support: '联系支持',
    actions: ['浏览服务', '查看需求', '完善资料'],
    topics: [
      { title: '开始使用', text: '注册后完善资料，选择浏览服务、发布需求或联系服务者。平台会把沟通、订单和评价集中在同一个工作台。' },
      { title: '交易安全', text: '下单前确认服务范围、交付时间、预算、验收标准和取消规则。合同前沟通和付款建议保留在平台内完成。' },
      { title: '发布需求', text: '描述目标、交付物、预算范围和截止时间。范围越清晰，收到的方案越容易比较。' },
      { title: '获得支持', text: '如果遇到账户、订单或付款问题，请准备需求编号、订单编号和相关聊天记录，便于快速定位。' },
    ],
  } : {
    title: 'Help Center',
    subtitle: 'Understand the core Oblitrok workflows and find the next step when something needs attention.',
    support: 'Contact support',
    actions: ['Browse services', 'View requirements', 'Complete profile'],
    topics: [
      { title: 'Getting started', text: 'After signing up, complete your profile, browse services, post requirements, or contact providers. Messages, orders, and reviews stay in one workspace.' },
      { title: 'Transaction safety', text: 'Before ordering, confirm scope, delivery time, budget, acceptance criteria, and cancellation rules. Keep pre-contract chat and payments on platform.' },
      { title: 'Posting requirements', text: 'Describe the goal, deliverables, budget range, and deadline. Clearer scope makes proposals easier to compare.' },
      { title: 'Getting support', text: 'For account, order, or payment issues, prepare requirement IDs, order IDs, and relevant chat records so support can locate the issue faster.' },
    ],
  };
  return (
    <div className="help-page page-shell-page">
      <div className="container help-shell">
        <section className="help-hero">
          <div>
            <h1>{text.title}</h1>
            <p>{text.subtitle}</p>
          </div>
          <Link to="/messages?support=1" className="help-primary">{text.support}</Link>
        </section>

        <section className="help-grid">
          {text.topics.map(topic => (
            <article className="help-card" key={topic.title}>
              <h2>{topic.title}</h2>
              <p>{topic.text}</p>
            </article>
          ))}
        </section>

        <section className="help-actions">
          <Link to="/services">{text.actions[0]}</Link>
          <Link to="/tasks">{text.actions[1]}</Link>
          <Link to="/profile">{text.actions[2]}</Link>
        </section>
      </div>
    </div>
  );
}
